export const shouldShowServiceFee = (amountCents: number | null | undefined, featureEnabled: boolean): boolean =>
  featureEnabled && (amountCents ?? 0) > 0;
